import React from 'react';

import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,

);